import React, { useState } from 'react';
import { useMessageManagerProvider } from '../../../../../context/messageManager';
import { Button } from '../../../../../../components/Common/UI/Button';
import Icons from '../../../../../../components/Common/Icons/Icons';
import { ICriteriaData } from '../CriteriaList';
import Separator from '../../../../../../components/Common/UI/Separator';
import { cn } from '../../../../../../utils/styles';
import EmptyModel from './Empty';
import { CompanyInfo } from '../Step2/Tabs/Statement';
import QuillRichTextEditor from '../../../../Common/QuillRichTextEditor';
import { Input } from '../../../../../../components/Common/UI/Input';
import { builderStep2DataEndOfStatement } from '../Data';
import { MenuPopoverContent, Popover, PopoverTrigger } from '../../../../../../components/Common/UI/Popover';

const generatedData: ICriteriaData[] = [
  {
    id: '1',
    type: 'Account Number',
    input: '12345',
  },
  {
    id: '2',
    type: 'Interest Rate',
    input: '2',
  },
  {
    id: '3',
    type: 'Zip Code',
    input: '12345',
  },
  {
    id: '4',
    type: 'Product Type',
    input: 'Checking',
  },
  {
    id: '5',
    type: 'End Balance',
    input: '12345',
  },
  {
    id: '5',
    type: 'Maturity Days',
    input: '20',
  },
  {
    id: '6',
    type: 'Loan Desc',
    input: 'Home',
  },
];

function BuilderStepThree() {
  const { state } = useMessageManagerProvider();
  const [generate, setGenerate] = useState<ICriteriaData[]>([]);

  const handleGenerate = () => {
    setGenerate(generatedData);
  };

  return (
    <div className={cn('grid grid-cols-[45%,1fr] gap-x-[20px]', { 'items-start': state.step3.isEdit })}>
      <div
        className="grid bg-white gap-y-[10px] content-start border py-[20px] px-[30px] overflow-y-auto
      h-[calc(100vh-84px)]"
      >
        <div className="grid gap-2 grid-cols-2 justify-between">
          <CompanyInfo />
          {generate.length ? (
            <div
              className="flex w-[300px] h-[300px] bg-lightGray2 items-center justify-self-end rounded-lg
                 overflow-hidden justify-center mt-[50px] border"
            >
              {state?.step2?.statement?.data[0]?.imageUrl ? (
                <img alt="module" src="/infoTrac/images/image011.png" className={cn('w-full h-full object-contain')} />
              ) : null}
            </div>
          ) : (
            <div className="h-[300px]" />
          )}
        </div>
        <div className="my-[20px]">
          {generate.length ? (
            state?.step2?.statement.data[0]?.content?.map((el, index) => (
              <QuillRichTextEditor key={`${index + 1}`} autoHeight value={el || ''} hideToolbar readOnly />
            ))
          ) : (
            <div className="h-[200px]" />
          )}
        </div>
        <img src="/infoTrac/images/step-2-tables.png" alt="image3" className="self-end" />
        {generate.length ? (
          <div className="mt-[30px]">
            <img alt="generated" src={builderStep2DataEndOfStatement[1].imageUrl} className={cn('self-end')} />
          </div>
        ) : null}
      </div>
      <div className="bg-white grid border">
        {state.step3.isEdit ? (
          <div className="grid grid-rows gap-[20px] content-start">
            {generate.length ? (
              <div>
                <div className="text-xl text-center font-bold text-primary px-[10px] pt-[10px] mb-[20px]">
                  Now Viewing Document Preview for the Following Criteria
                </div>
                <div className="bg-primary-5 border rounded-lg px-[22px] py-[15px] mx-[10px] mb-[20px]">
                  <div className="flex flex-wrap gap-y-[20px] justify-center">
                    {generate.map((el, index) => (
                      <div key={el.id} className="grid grid-cols-[1fr,auto] items-center">
                        <div>
                          <div className="text-primary text-sm capitalize">
                            {el.type}
                            <span className="font-medium text-[13px] ml-[5px] lowercase">equals</span>
                          </div>
                          <div className="text-primary font-bold text-center">{el.input}</div>
                        </div>
                        {index !== generate.length - 1 ? (
                          <div
                            className="uppercase text-primary opacity-60 text-[12px] w-[40px] h-[20px]
                          flex items-center bg-primary-7 font-medium rounded-lg justify-center mx-[20px]"
                          >
                            and
                          </div>
                        ) : null}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="text-primary text-center">
                  Adjust the criteria below to
                  <span className="font-bold ml-[5px]">Generate a new preview</span>
                </div>
                <Separator className="mt-[20px]" />
              </div>
            ) : null}
            <div>
              <div className="text-xl font-medium text-white text-center p-[10px] bg-primary">
                {generate.length ? 'Criteria' : 'Test Criteria'}
              </div>
              <div className="text-lg text-center p-[15px] pb-[10px] text-primary uppercase">
                Please enter your test values in the below spaces
              </div>
              <div className="text-addition1-50 pb-[20px] text-center">
                You must enter a value for each criteria option below in order to generate an accurate preview
              </div>
              <Separator className="mb-[20px]" />
            </div>
            <div className="grid gap-[20px] justify-center">
              <div className="grid grid-cols-[auto_450px] gap-[20px]">
                <Input
                  className="font-bold w-[180px]"
                  inputClassName="!border-input !cursor-auto disabled:opacity-1"
                  value="Account Number"
                  disabled
                  readOnly
                />
                <Input placeholder="value" inputClassName="w-full" />
              </div>
              <div className="grid grid-cols-[auto_450px] gap-[20px]">
                <Input
                  className="font-bold w-[180px]"
                  inputClassName="!border-input !cursor-auto disabled:opacity-1"
                  value="Interest Rate"
                  disabled
                  readOnly
                />
                <Input placeholder="value" inputClassName="w-full" />
              </div>
              <div className="grid grid-cols-[auto_450px] gap-[20px]">
                <Input
                  className="font-bold w-[180px]"
                  inputClassName="!border-input !cursor-auto disabled:opacity-1"
                  value="Zip"
                  disabled
                  readOnly
                />
                <Input placeholder="value" inputClassName="w-full" />
              </div>
              <div className="grid grid-cols-[auto_450px] gap-[20px]">
                <Input
                  className="font-bold w-[180px]"
                  inputClassName="!border-input !cursor-auto disabled:opacity-1"
                  value="Product Type"
                  disabled
                  readOnly
                />
                <Input placeholder="value" inputClassName="w-full" />
              </div>
              <div className="grid grid-cols-[auto_450px] gap-[20px]">
                <Input
                  className="font-bold w-[180px]"
                  inputClassName="!border-input !cursor-auto disabled:opacity-1"
                  value="End Balance"
                  disabled
                  readOnly
                />
                <Input placeholder="value" inputClassName="w-full" />
              </div>
              <div className="grid grid-cols-[auto_450px] gap-[20px]">
                <Input
                  className="font-bold w-[180px]"
                  inputClassName="!border-input !cursor-auto disabled:opacity-1"
                  value="Maturity Days"
                  disabled
                  readOnly
                />
                <Input placeholder="value" inputClassName="w-full" />
              </div>
              <div className="grid grid-cols-[auto_450px] gap-[20px]">
                <Input
                  className="font-bold w-[180px]"
                  inputClassName="!border-input !cursor-auto disabled:opacity-1"
                  value="Loan Desc"
                  disabled
                  readOnly
                />
                <Input placeholder="value" inputClassName="w-full" />
              </div>
            </div>
            <Separator className="m-0" />
            {/* <div className="flex justify-end px-[10px]">
              <Button
                variant="outline"
                className="!text-addition5 border-addition5 px-[10px] pr-0 py-0 mb-[20px]"
                onClick={handleGenerate}
              >
                <Icons.EyeFilled className="[&_path]:fill-addition5" />
                Generate E Preview
                <div className="ml-[5px] h-full flex items-center justify-center border-l border-l-addition5 px-[10px]">
                  <Icons.ArrowRight className="[&_path]:fill-addition5 rotate-90" />
                </div>
              </Button>
            </div> */}
            <div className="flex justify-end px-[10px] relative">
              <Button
                variant="outline"
                className="!text-addition5 border-addition5 px-[10px] pr-0 py-0 mb-[20px]"
                onClick={handleGenerate}
              >
                <Icons.EyeFilled className="[&_path]:fill-addition5" />
                Generate E Preview
                <div
                  className="ml-[5px] h-full flex items-center justify-center border-l border-l-addition5 px-[10px]"
                  tabIndex={-1}
                  role="button"
                  onClick={e => e.stopPropagation()}
                >
                  <Popover>
                    <PopoverTrigger>
                      <Icons.ArrowRight className="[&_path]:fill-addition5 rotate-90" />
                    </PopoverTrigger>
                    <MenuPopoverContent>
                      <div
                        tabIndex={-1}
                        role="button"
                        className="cursor-pointer px-4 py-2 hover:bg-muted flex gap-1 items-center text-blue-500"
                        onClick={handleGenerate}
                      >
                        <Icons.PDF3 className="text-purple-500" />
                        Generate Print Preview
                      </div>
                    </MenuPopoverContent>
                  </Popover>
                </div>
              </Button>
            </div>
          </div>
        ) : (
          <EmptyModel />
        )}
      </div>
    </div>
  );
}

export default BuilderStepThree;
